export class StringHelper {
    public static zeroPaddedString(string?: string) {
        return string ? ("0" + string).slice(-2) : undefined;
    }
}
